import 'slick-carousel'

$(document).ready(function () {
  $('.custom-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
